import Backbone from 'backbone'
// import Logger from 'Logger'

import tpl from './loading.mustache'
import { loadingModel } from '../../store/loding.model'

export var LoadingView = Backbone.View.extend({
  template: tpl,
  model: loadingModel,
  initialize: function () {
    // this.model.off()
    this.model.on('change:isLoading', this.toggle, this)
    this.render()
  },
  toggle: function () {
    var isLoading = this.model.get('isLoading')
    var onClass = 'is-loading--true'
    var $el = this.$el.find('.poker-mall-loading')
    if (isLoading) {
      $el.addClass(onClass)
    } else {
      $el.removeClass(onClass)
    }
  },
  render: function () {
    var rendered = this.template.render(this.model.toJSON())
    this.$el.empty().html(rendered)
    return this
  },
})
